import type { QuoteFileVisibility } from 'paintscout'

export interface ShowOn {
  estimate: boolean
  workOrder: boolean
}

export function visibilityToShowOn(visibility?: QuoteFileVisibility): ShowOn {
  switch (visibility) {
    case 'visible':
      return { estimate: true, workOrder: true }
    case 'customer':
      return { estimate: true, workOrder: false }
    case 'crew':
      return { estimate: false, workOrder: true }
    case 'hidden':
      return { estimate: false, workOrder: false }
    default:
      return { estimate: true, workOrder: true }
  }
}

export function showOnToVisibility({ estimate, workOrder }: ShowOn): QuoteFileVisibility {
  if (estimate && workOrder) return 'visible'
  if (estimate) return 'customer'
  if (workOrder) return 'crew'
  return 'hidden'
}
